/* eslint-disable react-hooks/rules-of-hooks */
import { Fetch } from 'helpers/fetchWrapper';

const notificationService = {
  _url: `${process.env.REACT_APP_USERS_API_URL}-users`,

  async markAsRead(payload) {
    let res = await Fetch.post(`${this._url}/mark-as-read`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getNotifications() {
    let res = await Fetch.get(`${this._url}/get-notifications`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};

export default notificationService;
